<template>
<v-card>
  <request-status :request="req" message200="Changes saved" />
  <v-card-title class="grey overline lighten-4 py-1" >
    <v-chip-group v-model="selectedSpace" active-class="primary" >
      <v-chip v-for="space in spaces" small
        :value="space"
        :key="space.id" >{{ space.title }}</v-chip>
    </v-chip-group>
    <v-spacer />
    <v-btn small icon @click="$emit('close')" ><v-icon small >mdi-close</v-icon></v-btn>
  </v-card-title>
  <v-divider/>

  <v-card-text>

    <v-expansion-panels tile class="mt-3" >
      <v-expansion-panel
        v-for="product in products" :key="product.id" >
        <v-expansion-panel-header>
          {{product.title}}
          <small v-if="product.notes" class="ml-2 grey--text" >{{ product.notes }}</small>
          <small v-else class="warning--text ml-2" >** has no custom notes **</small>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-textarea outlined
            label="Product notes"
            v-model="product.notes" />
          <v-btn @click="save(product.id, product.notes)" >Save</v-btn>
          <!-- <pre v-text="product" class="caption grey lighten-4 pa-3" /> -->
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

  </v-card-text>
</v-card>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ProductNotes',
  data () {
    return {
      selectedSpace: null,
      req: {
        resource: 'ag.spaces',
        method: 'patch'
      }
    }
  },
  mounted () {
    if (this.spaces && this.spaces.length > 0) {
      this.selectedSpace = this.spaces[0]
    }
  },
  computed: {
    ...mapGetters ('identity', ['getProducts', 'getSpacesByPractitionerId', 'meId']),
    spaces () {
      return this.getSpacesByPractitionerId(this.meId)
    },
    selectedSpaceId () {
      return this.getObjectPath(this.selectedSpace, 'id')
    },
    products () {
      if (this.selectedSpace && this.meId) {
        let options = {
          spaceId: this.selectedSpaceId,
          practitionerId: this.meId
        }
        console.log(options)
        return this.getProducts(options)
      }
      return []
    }
  },
  methods: {
    save (productId, notes) {
      if (this.selectedSpaceId) {
        this.req.resourceId = this.selectedSpaceId
        this.req.extra = 'appointment-types/' + productId
        this.req.data = {notes}
        this.$request('save', this.req)
        // /api/v3/spaces/271/appointment-types/4734/
      }
    }
  }
}
</script>
